/* eslint-disable */
import { SHOW_CONSOLE } from '../../config';
const consoleSistema = (page, message, linea = 0) => {
    //Variable en config global que muestra o no la consola
    //Ejemplo: consoleSistema("list-compra-view", "Presiona crear retencion compra: " + id_compras, 125);
    if (SHOW_CONSOLE){
        console.log("Pagina: " + page);
        console.log("Linea: " + linea);
        console.log("Mensaje: ");
        console.log(message);
    }
    return "Ok";
}



export default consoleSistema;